import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('[ErrorBoundary] Caught error:', error);
    console.error('[ErrorBoundary] Error info:', errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          padding: '40px',
          textAlign: 'center',
          fontFamily: 'Arial, sans-serif',
          backgroundColor: '#f5f5f5',
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}>
          <div style={{ maxWidth: '600px' }}>
            <h1 style={{ color: '#c00', marginBottom: '20px' }}>Oops! Something went wrong</h1>
            <p style={{ color: '#666', marginBottom: '20px', fontSize: '16px' }}>
              The website encountered an error while loading. Please try:
            </p>
            <ul style={{ textAlign: 'left', color: '#666', marginBottom: '30px' }}>
              <li>Refreshing the page (F5 or Ctrl+R)</li>
              <li>Clearing browser cache and trying again</li>
              <li>Checking if you have JavaScript enabled</li>
              <li>Contacting support if the problem persists</li>
            </ul>
            <details style={{ textAlign: 'left', padding: '10px', backgroundColor: '#eee', borderRadius: '4px' }}>
              <summary style={{ cursor: 'pointer', fontWeight: 'bold', color: '#666' }}>
                Technical Details (for developers)
              </summary>
              <pre style={{ marginTop: '10px', color: '#c00', overflow: 'auto', whiteSpace: 'pre-wrap' }}>
                {this.state.error && this.state.error.toString()}
              </pre>
            </details>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
